import {
	RepositoryEntrySchema,
	type RepositoryEntry,
} from '#app/routes/mocra+/_form+/components/repositories/schema.ts'
import {
	collectRepositoryErrors,
	createRepositoryDraft,
	repositoryDraftToEntry,
	repositoryEntryToDraft,
	sanitizeRepositoryDraft,
	type RepositoryDraft,
} from '#app/routes/mocra+/_form+/components/repositories/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const repositoryDefinition = assertEntityDefinition<
	RepositoryEntry,
	RepositoryDraft
>({
	schema: RepositoryEntrySchema,
	createDraft: () => createRepositoryDraft(),
	sanitizeDraft: sanitizeRepositoryDraft,
	serialize: repositoryDraftToEntry,
	deserialize: repositoryEntryToDraft,
	collectErrors: collectRepositoryErrors,
})

export type RepositoryEntityDraft = RepositoryDraft
